(ns app.domain.branding.model
  (:require [app.domain.group.model :as group-model]
            [clojure.set :as set]
            [clojure.string :as str]
            [core.util.normalize :as normalize]))

(def default-branding "gov")

(def website-branding-attributes [:group/branding-banner-fg-color
                                  :group/branding-banner-bg-color
                                  :group/branding-background-hue
                                  :group/branding-login-info-title
                                  :group/branding-login-info
                                  :group/branding-landing-page-large-header?
                                  :group/dynamic-calls-to-action])

(defn- workspace-branding [workspace]
  (->> workspace :domain/authority-group :entity/parent :group/uri-path-id))

(defn- group-branding [group]
  (cond
    (nil? group)
    nil

    (group-model/domain? group)
    (:group/uri-path-id group)

    (group-model/superdomain? group)
    (:group/uri-path-id group)

    :else
    (recur (:entity/parent group))))

(defn or-default [branding]
  (or branding default-branding))

(defmulti entity-branding
  "Returns the :group/uri-path-id defined in the domain group or fallbacks to default-branding"
  (fn [entity] (-> entity :entity/type)))

(defmethod entity-branding :default [entity]
  (-> entity :entity/parent workspace-branding or-default))

(defmethod entity-branding :entity.type/workspace [entity]
  (-> entity workspace-branding or-default))

(defmethod entity-branding :entity.type/group [entity]
  (-> entity group-branding or-default))

(defmethod entity-branding :entity.type/booking [entity]
  (-> entity :entity/parent :entity/parent :entity/parent workspace-branding or-default))

(defn image-url [brand image-type id]
  (str "/api/command/group/get-branding-image?image-type=" image-type "&brand=" brand "&id=" id))

(def image-types
  [:logo
   :background
   :landing-background])

(def image-type->attribute
  {:logo               :group/branding-logo
   :background         :group/branding-login-background
   :landing-background :group/branding-landing-background})

(def attribute->image-type (set/map-invert image-type->attribute))

(def views-before-branding ["dashboard" "licence-search" "contractor-registration-search" "login" "my-profile"
                            "reset-password" "group" "registration" "create-application" "project" "conversations"
                            "workspace" "inspections" "committees" "code-enforcement" "licences" "business"
                            "contractor-registration" "admin" "public-notice" "decision-download" "property" "map"])

(def other-banned-brandings [default-branding "asset" "i18n" "healthz" "dev" "api" "application"])

(def banned-brandings (set (concat views-before-branding other-banned-brandings)))

(defn images-map [group]
  (->> (select-keys group [:group/branding-logo :group/branding-login-background :group/branding-landing-background])
       (map (juxt first (comp #(get % :db/id (identity %)) second)))
       (into {})))

(defn uri-path-id-with-fallback
  "Returns the normalized uri-path-id using the left-most subdomain of group domain, group name or group id,
   falling back as needed if the value is blank, in the list of banned brandings or not unique."
  [group-domain group-name group-id unique?]
  (let [valid?                #(and (not (str/blank? %))
                                    (not (banned-brandings %))
                                    (unique? %))
        left-most-subdomain   (some->> group-domain
                                       (re-find #"^([^.]+)\..+$")
                                       second
                                       normalize/hyphenated-string)
        group-name-normalized (normalize/hyphenated-string group-name)]
    (cond
      (valid? left-most-subdomain)
      left-most-subdomain

      (valid? group-name-normalized)
      group-name-normalized

      :else
      (some-> group-id str/lower-case))))
